import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_3 = { class: "card-body p-xl-40" }
const _hoisted_4 = { class: "row g-3 align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = { class: "search-box position-relative" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "d-flex justify-content-lg-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_IncomeCategory = _resolveComponent("IncomeCategory")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CreateIncomeCategoryModal = _resolveComponent("CreateIncomeCategoryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "income_category" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  placeholder: _ctx.$t('income_category_page.search_placeholder'),
                  class: "form-control bg-white h-55 shadow-none pe-5"
                }, null, 8, _hoisted_7), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "search-icon" }, [
                  _createElementVNode("i", { class: "ri-search-line" })
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-one d-inline-flex align-items-center h-55 px-4",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#incomeCategoryModal",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
                }, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-add-circle-line me-1" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("income_category_page.create_category")), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_IncomeCategory, {
        categories: _ctx.categories,
        loading: _ctx.loading,
        onEditCategory: _ctx.openEditModal,
        onDeleteCategory: _ctx.deleteCategory
      }, null, 8, ["categories", "loading", "onEditCategory", "onDeleteCategory"]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _createVNode(_component_CreateIncomeCategoryModal, {
      form: _ctx.form,
      loading: _ctx.saving,
      "is-edit-mode": _ctx.isEditMode,
      onUpdateField: _ctx.updateField,
      onGenerateCode: _ctx.generateCode,
      onSubmit: _ctx.submitCategory
    }, null, 8, ["form", "loading", "is-edit-mode", "onUpdateField", "onGenerateCode", "onSubmit"])
  ], 64))
}